module.exports = __webpack_public_path__ + "img/necta.1b7a9de2.png";